/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-promise-reject-errors */
// API request usign Axios library

import axios from 'axios'

const apiEndpoint = process.env.VUE_APP_API_LINK;

export default {
  install(Vue, options) {
    Vue.prototype.$XHR = {
      // POST API request
      post(payload, uploadProgress = null) {
        return new Promise((resolve, reject) => {
          const bodyFormData = new FormData()

          for (const e in payload) {
            if (Object.prototype.hasOwnProperty.call(payload, e)) {
              bodyFormData.append(e, payload[e])
            }
          }

          const config = {
            method: 'post',
            url: apiEndpoint,
            data: bodyFormData,
            headers: { 'Content-Type': 'multipart/form-data' },
          }

          if (uploadProgress != null) {
            config.onUploadProgress = uploadProgress
          }

          axios(config).then(response => {
            // handle server response
            if (response.data !== undefined && response.data.status !== undefined) {
              if (response.data.status !== undefined && response.data.result !== undefined) {
                if (response.data.status === 'success') {
                  resolve(response.data.result);
                } else {
                  reject({
                    "result": "fail",
                    "data": response.data.result
                  });
                }
              } else if (response.data.result !== undefined && response.data.data !== undefined) {
                if (response.data.result === 'success') {
                  resolve(response.data.data);
                } else {
                  reject({
                    "result": "fail",
                    "data": response.data.data
                  });
                }
              } else {
                console.error('[API] POST failed (non-successful result)')
                reject({
                  "result": "fail",
                  "data": response.data
                });
              }
            } else {
              console.error('[API] POST failed (missing data or result)')
              reject({
                "result": "fail",
                "data": "message.errorOccur"
              })
            }

          }).catch(response => {
            // handle error
            console.error('[API] POST failed (connection exception)')
            reject({
              "result": "fail",
              "data": "message.errorOccur"
            })
          })
        })
      },

      async api(key, passObj) {
        const params = new URLSearchParams();
        params.set(key, JSON.stringify(passObj));
        const response = await axios.post(apiEndpoint, params.toString());
        const result = response.data;
        if (result.status === 'success' || result.result === 'success') {
          let data = null;
          if (result.status === 'success') {
            data = result.result;
          } else {
            data = result.data;
          }

          delete result.status
          delete result.result
          delete result.data

          if (Object.keys(result).length > 0) {
            if (result.total !== undefined && result.total !== null && result.total !== '') {
              return Promise.resolve({ data: data, total: result.total });
            } else {
              return Promise.resolve({ data: data, ...result });
            }
          }

          return Promise.resolve(data);

        } else if ((result.status === 'fail' && result.result) || (result.result === 'fail' && result.data)) {
          let data = null;
          if (result.status === 'fail') {
            data = result.result;
          } else {
            data = result.data;
          }

          const rejectResult = {
            "result": "fail",
            "data": typeof data === 'string' ? data.trim() : JSON.stringify(data)
          };

          if (result.feedback !== undefined && result.feedback !== null && result.feedback !== "") {
            rejectResult["feedback"] = result.feedback
          }

          return Promise.reject(rejectResult)
        } else if (key === 'get_general_setting') {
          if (result.logo !== undefined && result.custom_text !== undefined) {
            return Promise.resolve(result);
          }
        }

        return Promise.reject({
          "result": "fail",
          "data": "message.errorOccur"
        })
      },

      async get(url) {
        try {
          const response = await axios.get(url);
          // The JSON data is automatically parsed and available in response.data
          return Promise.resolve(response.data);
        } catch (error) {
          console.error('Error fetching data:', error);
          return Promise.reject(null);
        }
      }
    }
  },
}
